import { createApi } from '@reduxjs/toolkit/query/react';
import { createBearerBaseQuery } from '../../shared/rtk-bearer-base-query';
import { ENVIRONMENT } from '../../constants/env-constants';

export const myStatsApi = createApi({
  reducerPath: 'my-stats-maps-redux-query',
  baseQuery: createBearerBaseQuery(`${ENVIRONMENT.BACKEND_SERVER}/api/stats/my-stats/map`),
  endpoints: (builder) => {
    return {
      getMyRepossessedStatsMap: builder.query({
        query: ({ startDate, endDate, userId }) =>
          `/repossessed?startDate=${startDate}&endDate=${endDate}&userId=${userId}`,
      }),
      getMySpottedStatsMap: builder.query({
        query: ({ startDate, endDate, userId }) =>
          `/spotted?startDate=${startDate}&endDate=${endDate}&userId=${userId}`,
      }),
    };
  },
});

export const { useGetMyRepossessedStatsMapQuery, useGetMySpottedStatsMapQuery } = myStatsApi;
